/**
 * UTM / 広告パラメータの cookie 永続化
 *
 * 広告から着地した URL に `?utm_source=...&utm_campaign=...&utm_medium=...`
 * 等が付いてきた場合に、cookie に保存する (90 日)。
 * 後続ページに遷移してフォーム送信した時にも値が残るよう、cookie で持つのがミソ。
 *
 * 利用箇所:
 *   - register-lead.js   sendmail / createLead の payload で getCookie() 経由で参照
 *   - inc/contact.php    wpcf7_form_hidden_fields で $_COOKIE を hidden 化して
 *                        /inquire (CF7) のメール本文に挿入 / Pipedrive にも渡る
 *
 * 旧 Concrete は GTM 等の経路でこの cookie が生成されていた前提なので、WP 側で同等の
 * 仕組みを JS で素直に再現する。
 */
const UTM_KEYS = [
  "utm_source",
  "utm_campaign",
  "utm_medium",
  "ad_cp",
  "ad_adgroup",
];
const COOKIE_DAYS = 90;

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 86400 * 1000).toUTCString();
  document.cookie =
    `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function initUtmCapture() {
  const params = new URLSearchParams(window.location.search);
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) setCookie(key, value, COOKIE_DAYS);
  }
}
